const language = [
    { id: "english", label: "English" },
    { id: "hindi", label: "Hindi" },
    { id: "gujarati", label: "Gujarati" },
    { id: "kannada", label: "Kannada" },
    { id: "telugu", label: "Telugu" },
    { id: "tamil", label: "Tamil" },
    { id: "malayalam", label: "Malayalam" },
]
export default language;